<template>
  <nav class="nav navbar navbar-expand-lg navbar-dark">
    <button class="navbar-toggler" style="position: relative; top: 0; left: -25px;" type="button" data-toggle="collapse" data-target="#hamburgerMenu" aria-controls="hamburgerMenu" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="hamburgerMenu">
      <ul class="navbar-nav mr-auto navbar--main">
        <li class="nav-item clickable">
          <a
            class="nav-link"
            @click="setLeagueId(1252869)"
            v-if="store.state.leagueId !== 1252869"
            >
            Change to Magic League
          </a>
          <a
            class="nav-link"
            @click="setLeagueId(268632)"
            v-if="store.state.leagueId !== 268632"
            >
            Change to Auction League
          </a>
        </li>
        <li class="nav-item clickable"><router-link to="/guillotine" class="nav-link">Guillotine</router-link></li>
        <li class="nav-item clickable"><router-link to="/leaguehistory" class="nav-link">League History</router-link></li>
        <li class="nav-item clickable"><router-link to="/titlebelt" class="nav-link">Title Belt</router-link></li>
        <li class="nav-item clickable"><router-link to="/leaderboards" class="nav-link">Leaderboards</router-link></li>
        <li class="nav-item clickable"><router-link to="/seasons" class="nav-link">Seasons</router-link></li>
        <li class="nav-item clickable"><router-link to="/schedulecomparison" class="nav-link">Schedule Comparison</router-link></li>
        <li class="nav-item clickable"><router-link to="/rank/freeforall" class="nav-link">FFA Rank</router-link></li>
        <li class="nav-item clickable"><router-link to="/donate" class="nav-link">Donations</router-link></li>
      </ul>
    </div>
  </nav>
  <router-view />
</template>

<script lang="ts">
import { useStore } from "vuex";
import Season from './shared/seasons/season';
import { teamApi } from './shared/teams/team-api';
export default {
  setup() {
    const store = useStore();

    async function getLeagueData() {
      if (!store.state.leagueId) return;

      const league: Season[] = await teamApi.getLeagueHistory(store.state.leagueId);
      store.dispatch('setLeague', league);
    }

    function setLeagueId(leagueId: number) {
      store.dispatch("setLeagueId", leagueId);
      getLeagueData();
    }

    getLeagueData();

    return { setLeagueId, store };
  },
};
</script>

<style lang="scss">
@import "./styles/index";
@import "./styles/variables";

body {
  background: $color-primary-background;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #f8f6e4;
  padding: 0 25px;
}

.navbar-main {
  border-bottom: 1px solid $color-secondary-background;
}

@media screen and (min-width: $width-medium) {
  #nav {
    a {
      font-weight: bold;
      color: #f8f6e4;

      &.router-link-exact-active {
        color: #4cc6de;
      }
    }
  }
}
</style>
